export enum MediaType {
  S3_VIDEO = "S3_VIDEO",
  S3_IMAGE = "S3_IMAGE",
  S3_PDF = "S3_PDF",
  YOUTUBE = "YOUTUBE",
}

export type MediaItemDraft = {
  id?: string | null
  url?: string
  awsS3Key?: string
  type: MediaType
  filename: string | null
}

export type MediaDraft = {
  medias: MediaItemDraft[]
}

export type Media = {
  id: string
  url: string
  type: MediaType
  filename: string | null
  key?: string | null // S3 key, for backward compatibility
}
